export default "__VITE_ASSET__DYlrIJhF__"